// import {
//   AccessTime,
//   CalendarMonth,
//   Payments,
//   Person,
//   ReceiptLong,
//   ShoppingBag, // Icon for Counter/Takeaway
//   TableRestaurant, // Icon for Table (Optional fallback)
// } from "@mui/icons-material";
// import {
//   Avatar,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   Divider,
//   Grid,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import moment from "moment";
// import { useEffect, useMemo, useState } from "react";
// import { getOrderStatusById, getOrderTypeLabel } from "../../constants/enums";
// import { mergeItemsByVariant } from "../../reduxStore/selectors/cartSelectors";
// import { formatCurrency } from "../../utils/currency";
// import OrderDetailsDrawer from "../order-details-drawer/OrderDetailsDrawer";
// import PaymentInfo from "../payment-info/PaymentInfo";

// // --- HELPER: Timer Logic ---
// const useOrderTimer = (createdAt, isActive) => {
//   const [elapsedMinutes, setElapsedMinutes] = useState(0);

//   useEffect(() => {
//     if (!isActive || !createdAt) return;

//     const calculateTime = () => {
//       const now = moment();
//       const start = moment(createdAt);
//       const duration = moment.duration(now.diff(start));
//       setElapsedMinutes(Math.floor(duration.asMinutes()));
//     };

//     calculateTime();
//     const timer = setInterval(calculateTime, 60000);
//     return () => clearInterval(timer);
//   }, [createdAt, isActive]);

//   let statusColor = "#2e7d32"; // Green (Safe)
//   let bg = "#e8f5e9";

//   if (elapsedMinutes > 20) {
//     statusColor = "#d32f2f"; // Red (Critical)
//     bg = "#ffebee";
//   } else if (elapsedMinutes > 10) {
//     statusColor = "#ed6c02"; // Amber (Warning)
//     bg = "#fff7ed";
//   }

//   return { timeLabel: `${elapsedMinutes} min`, color: statusColor, bg };
// };

// export default function OrderCard({ order }) {
//   const [isSettleDialogOpen, setIsSettleDialogOpen] = useState(false);
//   const [isOrderDetailsDrawerOpen, setIsOrderDetailsDrawerOpen] =
//     useState(false);

//   // 1. Data Extraction
//   const dine = order?.dine || {};
//   const orderStatus = getOrderStatusById(order.order_status_id);
//   const allItems = useMemo(
//     () => mergeItemsByVariant(order?.kots || []),
//     [order],
//   );
//   const orderTypeLabel = getOrderTypeLabel(order.order_type_id);

//   // 2. Logic: Status & Timer
//   const isCompletedOrCancelled = ["Completed", "Cancelled"].includes(
//     orderStatus?.label,
//   );
//   const isActive = !isCompletedOrCancelled;
//   const {
//     timeLabel,
//     color: timeColor,
//     bg: timeBg,
//   } = useOrderTimer(order.created_at, isActive);
//   const stripColor = isActive
//     ? timeColor
//     : orderStatus?.label === "Completed"
//       ? "#757575"
//       : "#d32f2f";

//   const itemsToShow = allItems.slice(0, 3);
//   const remainingCount = allItems.length - 3;
//   const customerName = order.name || order.customer?.name || "Guest";

//   // 3. Logic: Avatar Display (Table vs Counter)
//   // If we have a table name, show it. Otherwise, show an Icon or "TA"
//   const avatarContent = dine?.table?.table_name ? (
//     dine.table.table_name
//   ) : (
//     <ShoppingBag sx={{ fontSize: "20px" }} />
//   );

//   return (
//     <>
//       <Grid item xs={12} sm={6} md={4} lg={3}>
//         <Card
//           elevation={0}
//           sx={{
//             borderRadius: "12px",
//             border: "1px solid #e0e0e0",
//             height: "100%",
//             display: "flex",
//             flexDirection: "column",
//             position: "relative",
//             transition: "all 0.2s ease-in-out",
//             "&:hover": {
//               boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
//               transform: "translateY(-2px)",
//               borderColor: "primary.main",
//             },
//           }}
//         >
//           {/* --- LEFT STATUS STRIP --- */}
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               bottom: 0,
//               width: "4px",
//               bgcolor: stripColor,
//               borderRadius: "12px 0 0 12px",
//             }}
//           />

//           <CardContent sx={{ p: 2, flexGrow: 1 }}>
//             {/* 1. HEADER SECTION */}
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="flex-start"
//               mb={2}
//             >
//               {/* LEFT: Identity */}
//               <Box display="flex" gap={1.5} sx={{ minWidth: 0, flex: 1 }}>
//                 <Avatar
//                   variant="rounded"
//                   sx={{
//                     bgcolor: "grey.800",
//                     color: "white",
//                     width: 44,
//                     height: 44,
//                     fontSize: "16px",
//                     fontWeight: "bold",
//                     borderRadius: "8px",
//                     flexShrink: 0, // Prevent Avatar from squishing
//                   }}
//                 >
//                   {avatarContent}
//                 </Avatar>

//                 <Box sx={{ minWidth: 0, flex: 1 }}>
//                   <Typography
//                     variant="subtitle2"
//                     fontWeight={700}
//                     lineHeight={1.2}
//                     noWrap
//                   >
//                     #{order.order_number}
//                     <span
//                       style={{
//                         fontWeight: 400,
//                         color: "#777",
//                         marginLeft: "4px",
//                       }}
//                     >
//                       / {orderTypeLabel}
//                     </span>
//                   </Typography>

//                   {dine?.dine_area_name && (
//                     <Typography
//                       variant="caption"
//                       color="text.secondary"
//                       display="block"
//                       noWrap
//                     >
//                       {dine.dine_area_name}
//                     </Typography>
//                   )}

//                   <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
//                     <Person
//                       sx={{
//                         fontSize: 12,
//                         color: "text.secondary",
//                         flexShrink: 0,
//                       }}
//                     />
//                     <Typography
//                       variant="caption"
//                       fontWeight={600}
//                       color="text.primary"
//                       noWrap
//                     >
//                       {customerName}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Box>

//               {/* RIGHT: Status & Time */}
//               <Box
//                 display="flex"
//                 flexDirection="column"
//                 alignItems="flex-end"
//                 gap={0.5}
//                 sx={{ flexShrink: 0 }}
//               >
//                 <Chip
//                   label={orderStatus?.label || "Pending"}
//                   size="small"
//                   variant="outlined"
//                   sx={{
//                     height: 20,
//                     fontSize: "10px",
//                     fontWeight: 600,
//                     borderColor: "#ddd",
//                     color: "#555",
//                   }}
//                 />

//                 {isActive ? (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                       bgcolor: timeBg,
//                       color: timeColor,
//                       px: 1,
//                       py: 0.2,
//                       borderRadius: "4px",
//                     }}
//                   >
//                     <AccessTime sx={{ fontSize: 12 }} />
//                     <Typography variant="caption" fontWeight={700}>
//                       {timeLabel}
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Box
//                     display="flex"
//                     alignItems="center"
//                     gap={0.5}
//                     sx={{ color: "text.secondary", mt: 0.5 }}
//                   >
//                     <CalendarMonth sx={{ fontSize: 12 }} />
//                     <Typography variant="caption" sx={{ fontSize: "10px" }}>
//                       {moment(order.created_at).format("DD MMM, hh:mm A")}
//                     </Typography>
//                   </Box>
//                 )}
//               </Box>
//             </Box>

//             <Divider sx={{ borderStyle: "dashed", mb: 2 }} />

//             {/* 2. ITEM LIST (Fixed Truncation) */}
//             <Box display="flex" flexDirection="column" gap={1}>
//               {itemsToShow.map((item, idx) => (
//                 <Box
//                   key={idx}
//                   display="flex"
//                   justifyContent="space-between"
//                   alignItems="center"
//                 >
//                   {/* Item Wrapper - Critical for truncation */}
//                   <Box
//                     display="flex"
//                     alignItems="center"
//                     gap={1}
//                     sx={{ minWidth: 0, flex: 1, marginRight: "8px" }}
//                   >
//                     <Box
//                       sx={{
//                         minWidth: "24px",
//                         height: "24px",
//                         bgcolor: "#f5f5f5",
//                         borderRadius: "6px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: "12px",
//                         fontWeight: 600,
//                         color: "text.primary",
//                         flexShrink: 0, // Prevent quantity badge from squishing
//                       }}
//                     >
//                       {item.quantity}
//                     </Box>

//                     {/* The Name with Truncation */}
//                     <Tooltip title={item.variant_name} arrow placement="top">
//                       <Typography
//                         variant="body2"
//                         noWrap // This adds text-overflow: ellipsis
//                         sx={{
//                           fontWeight: 500,
//                           color: "text.primary",
//                           cursor: "default",
//                           display: "block", // Ensures noWrap works correctly
//                         }}
//                       >
//                         {item.variant_name}
//                       </Typography>
//                     </Tooltip>
//                   </Box>

//                   {/* Price - Fixed width prevents jumping */}
//                   <Typography
//                     variant="body2"
//                     fontWeight={600}
//                     color="text.secondary"
//                     sx={{ flexShrink: 0 }}
//                   >
//                     {formatCurrency(
//                       item.current_price.final_price * item.quantity,
//                     )}
//                   </Typography>
//                 </Box>
//               ))}

//               {remainingCount > 0 && (
//                 <Typography
//                   variant="caption"
//                   color="primary"
//                   fontWeight={600}
//                   sx={{
//                     cursor: "pointer",
//                     mt: 0.5,
//                     display: "inline-block",
//                     "&:hover": { textDecoration: "underline" },
//                   }}
//                   onClick={() => setIsOrderDetailsDrawerOpen(true)}
//                 >
//                   + {remainingCount} more items (View All)
//                 </Typography>
//               )}
//             </Box>
//           </CardContent>

//           {/* 3. FOOTER */}
//           <Box px={2} pb={2}>
//             <Box
//               display="flex"
//               justifyContent="space-between"
//               alignItems="center"
//               mb={2}
//               pt={1}
//             >
//               <Typography
//                 variant="body2"
//                 fontWeight={600}
//                 color="text.secondary"
//               >
//                 Total Bill
//               </Typography>
//               <Typography variant="h6" fontWeight={800} color="text.primary">
//                 {formatCurrency(order.total_amount)}
//               </Typography>
//             </Box>

//             <Grid container spacing={1}>
//               <Grid item xs={6}>
//                 <Button
//                   fullWidth
//                   variant="outlined"
//                   startIcon={<ReceiptLong sx={{ fontSize: 18 }} />}
//                   onClick={() => setIsOrderDetailsDrawerOpen(true)}
//                   sx={{
//                     textTransform: "none",
//                     fontWeight: 600,
//                     borderColor: "#e0e0e0",
//                     color: "text.secondary",
//                     "&:hover": {
//                       borderColor: "primary.main",
//                       color: "primary.main",
//                     },
//                   }}
//                 >
//                   Overview
//                 </Button>
//               </Grid>
//               <Grid item xs={6}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   color="warning"
//                   startIcon={<Payments sx={{ fontSize: 18 }} />}
//                   onClick={() => setIsSettleDialogOpen(true)}
//                   sx={{
//                     textTransform: "none",
//                     fontWeight: 600,
//                     boxShadow: "none",
//                     color: "white",
//                   }}
//                 >
//                   Pay Bills
//                 </Button>
//               </Grid>
//             </Grid>
//           </Box>
//         </Card>
//       </Grid>

//       {isSettleDialogOpen && (
//         <PaymentInfo
//           isSettleDialogOpen={isSettleDialogOpen}
//           onDialogCancel={() => setIsSettleDialogOpen(false)}
//         />
//       )}
//       <OrderDetailsDrawer
//         isOpen={isOrderDetailsDrawerOpen}
//         closeOrderDetailsDrawer={() => setIsOrderDetailsDrawerOpen(false)}
//         orderId={order.id}
//       />
//     </>
//   );
// }

import {
  AccessTime,
  BadgeOutlined, // Icon for Waiter
  CalendarMonth,
  Group, // Icon for Pax
  Payments,
  Person,
  Print, // Icon for Quick Print
  ReceiptLong,
  ShoppingBag,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { getOrderStatusById, getOrderTypeLabel } from "../../constants/enums";
import { mergeItemsByVariant } from "../../reduxStore/selectors/cartSelectors";
import { formatCurrency } from "../../utils/currency";
import OrderDetailsDrawer from "../order-details-drawer/OrderDetailsDrawer";
import PaymentInfo from "../payment-info/PaymentInfo";

// --- HELPER: Timer Logic ---
const useOrderTimer = (createdAt, isActive) => {
  const [elapsedMinutes, setElapsedMinutes] = useState(0);

  useEffect(() => {
    if (!isActive || !createdAt) return;

    const calculateTime = () => {
      const now = moment();
      const start = moment(createdAt);
      const duration = moment.duration(now.diff(start));
      setElapsedMinutes(Math.floor(duration.asMinutes()));
    };

    calculateTime();
    const timer = setInterval(calculateTime, 60000);
    return () => clearInterval(timer);
  }, [createdAt, isActive]);

  let statusColor = "#2e7d32"; // Green (Safe)
  let bg = "#e8f5e9";

  if (elapsedMinutes > 20) {
    statusColor = "#d32f2f"; // Red (Critical)
    bg = "#ffebee";
  } else if (elapsedMinutes > 10) {
    statusColor = "#ed6c02"; // Amber (Warning)
    bg = "#fff7ed";
  }

  return { timeLabel: `${elapsedMinutes} min`, color: statusColor, bg };
};

export default function OrderCard({ order }) {
  const [isSettleDialogOpen, setIsSettleDialogOpen] = useState(false);
  const [isOrderDetailsDrawerOpen, setIsOrderDetailsDrawerOpen] =
    useState(false);

  // 1. Data Extraction
  const dine = order?.dine || {};
  const orderStatus = getOrderStatusById(order.order_status_id);
  const allItems = useMemo(
    () => mergeItemsByVariant(order?.kots || []),
    [order],
  );
  const orderTypeLabel = getOrderTypeLabel(order.order_type_id);

  // New Fields
  const customerName = order.name || order.customer?.name || "Guest";
  const waiterName = order.waiter_name || order.user?.name || "Unassigned";
  const paxCount = order.pax || order.guest_count || 0;

  // 2. Logic: Status & Timer
  const isCompletedOrCancelled = ["Completed", "Cancelled"].includes(
    orderStatus?.label,
  );
  const isActive = !isCompletedOrCancelled;
  const {
    timeLabel,
    color: timeColor,
    bg: timeBg,
  } = useOrderTimer(order.created_at, isActive);
  const stripColor = isActive
    ? timeColor
    : orderStatus?.label === "Completed"
      ? "#757575"
      : "#d32f2f";

  const itemsToShow = allItems.slice(0, 3);
  const remainingCount = allItems.length - 3;

  // 3. Logic: Avatar Content
  const avatarContent = dine?.table?.table_name ? (
    dine.table.table_name
  ) : (
    <ShoppingBag sx={{ fontSize: "20px" }} />
  );

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Card
          elevation={0}
          sx={{
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              transform: "translateY(-2px)",
              borderColor: "primary.main",
            },
          }}
        >
          {/* --- LEFT STATUS STRIP --- */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              width: "4px",
              bgcolor: stripColor,
              borderRadius: "12px 0 0 12px",
            }}
          />

          {/* --- TOP RIGHT: QUICK PRINT --- */}
          <Box sx={{ position: "absolute", top: 12, right: 12, zIndex: 10 }}>
            <Tooltip title="Quick Print Bill">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  // Call your print logic here
                  console.log("Quick Print Triggered for", order.id);
                }}
                sx={{
                  color: "text.secondary",
                  bgcolor: "white",
                  border: "1px solid #eee",
                  padding: "4px",
                  "&:hover": { bgcolor: "#f5f5f5", color: "primary.main" },
                }}
              >
                <Print sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </Box>

          <CardContent sx={{ p: 2, flexGrow: 1 }}>
            {/* 1. HEADER SECTION */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
              mb={2}
            >
              {/* LEFT: Identity */}
              <Box
                display="flex"
                gap={1.5}
                sx={{ minWidth: 0, flex: 1, paddingRight: "30px" }}
              >
                <Avatar
                  variant="rounded"
                  sx={{
                    bgcolor: "grey.800",
                    color: "white",
                    width: 44,
                    height: 44,
                    fontSize: "16px",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    flexShrink: 0,
                  }}
                >
                  {avatarContent}
                </Avatar>

                <Box sx={{ minWidth: 0, flex: 1 }}>
                  {/* Row 1: Order ID + Type */}
                  <Typography
                    variant="subtitle2"
                    fontWeight={700}
                    lineHeight={1.2}
                    noWrap
                  >
                    #{order.order_number}
                    <span
                      style={{
                        fontWeight: 400,
                        color: "#777",
                        marginLeft: "4px",
                      }}
                    >
                      / {orderTypeLabel}
                    </span>
                  </Typography>

                  {/* Row 2: Area + Pax (New!) */}
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    {dine?.dine_area_name && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                      >
                        {dine.dine_area_name}
                      </Typography>
                    )}

                    {orderTypeLabel === "Dine In" && paxCount > 0 && (
                      <Chip
                        icon={
                          <Group style={{ fontSize: "12px", color: "#666" }} />
                        }
                        label={paxCount}
                        size="small"
                        variant="outlined"
                        sx={{
                          height: 18,
                          fontSize: "10px",
                          fontWeight: 600,
                          border: "1px solid #eee",
                          bgcolor: "#fafafa",
                          "& .MuiChip-label": { px: 0.5 },
                          "& .MuiChip-icon": { ml: 0.5 },
                        }}
                      />
                    )}
                  </Box>

                  {/* Row 3: Customer + Waiter (New!) */}
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    {/* Customer */}
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <Person sx={{ fontSize: 12, color: "text.secondary" }} />
                      <Typography
                        variant="caption"
                        fontWeight={600}
                        color="text.primary"
                        noWrap
                        sx={{ maxWidth: "70px" }}
                      >
                        {customerName}
                      </Typography>
                    </Box>

                    <Typography variant="caption" color="text.disabled">
                      •
                    </Typography>

                    {/* Waiter */}
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <BadgeOutlined
                        sx={{ fontSize: 12, color: "text.secondary" }}
                      />
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                        sx={{ maxWidth: "70px" }}
                      >
                        {waiterName}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* STATUS & TIME BAR (Moved below header for better fit with Print button) */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              {isActive ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    bgcolor: timeBg,
                    color: timeColor,
                    px: 1,
                    py: 0.2,
                    borderRadius: "4px",
                  }}
                >
                  <AccessTime sx={{ fontSize: 12 }} />
                  <Typography variant="caption" fontWeight={700}>
                    {timeLabel}
                  </Typography>
                </Box>
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  gap={0.5}
                  sx={{ color: "text.secondary" }}
                >
                  <CalendarMonth sx={{ fontSize: 12 }} />
                  <Typography variant="caption" sx={{ fontSize: "10px" }}>
                    {moment(order.created_at).format("DD MMM, hh:mm A")}
                  </Typography>
                </Box>
              )}
              <Chip
                label={orderStatus?.label || "Pending"}
                size="small"
                variant="outlined"
                sx={{
                  height: 20,
                  fontSize: "10px",
                  fontWeight: 600,
                  borderColor: "#ddd",
                  color: "#555",
                }}
              />
            </Box>

            <Divider sx={{ borderStyle: "dashed", mb: 2 }} />

            {/* 2. ITEM LIST */}
            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              sx={{
                maxWidth: "280px",
              }}
            >
              {itemsToShow.map((item, idx) => (
                <Box
                  key={idx}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ width: "100%", minWidth: 0 }}
                >
                  {/* Item Wrapper */}
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      minWidth: 0,
                      flex: 1,
                      marginRight: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        minWidth: "24px",
                        height: "24px",
                        bgcolor: "#f5f5f5",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "text.primary",
                        flexShrink: 0,
                      }}
                    >
                      {item.quantity}
                    </Box>

                    <Tooltip title={item.variant_name} arrow placement="top">
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          color: "text.primary",
                          cursor: "default",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: 0,
                          flex: 1,
                        }}
                      >
                        {item.variant_name}
                      </Typography>
                    </Tooltip>
                  </Box>

                  {/* Price */}
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    color="text.secondary"
                    sx={{ flexShrink: 0 }}
                  >
                    {formatCurrency(
                      item.current_price.final_price * item.quantity,
                    )}
                  </Typography>
                </Box>
              ))}

              {remainingCount > 0 && (
                <Typography
                  variant="caption"
                  color="primary"
                  fontWeight={600}
                  sx={{
                    cursor: "pointer",
                    mt: 0.5,
                    display: "inline-block",
                    "&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => setIsOrderDetailsDrawerOpen(true)}
                >
                  + {remainingCount} more items (View All)
                </Typography>
              )}
            </Box>
          </CardContent>

          {/* 3. FOOTER */}
          <Box px={2} pb={2}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
              pt={1}
            >
              <Typography
                variant="body2"
                fontWeight={600}
                color="text.secondary"
              >
                Total Bill
              </Typography>
              <Typography variant="h6" fontWeight={800} color="text.primary">
                {formatCurrency(order.total_amount)}
              </Typography>
            </Box>

            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<ReceiptLong sx={{ fontSize: 18 }} />}
                  onClick={() => setIsOrderDetailsDrawerOpen(true)}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "#e0e0e0",
                    color: "text.secondary",
                    "&:hover": {
                      borderColor: "primary.main",
                      color: "primary.main",
                    },
                  }}
                >
                  Overview
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  color="warning"
                  startIcon={<Payments sx={{ fontSize: 18 }} />}
                  onClick={() => setIsSettleDialogOpen(true)}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    boxShadow: "none",
                    color: "white",
                  }}
                >
                  Pay Bills
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Grid>

      {isSettleDialogOpen && (
        <PaymentInfo
          isSettleDialogOpen={isSettleDialogOpen}
          onDialogCancel={() => setIsSettleDialogOpen(false)}
        />
      )}
      <OrderDetailsDrawer
        isOpen={isOrderDetailsDrawerOpen}
        closeOrderDetailsDrawer={() => setIsOrderDetailsDrawerOpen(false)}
        orderId={order.id}
      />
    </>
  );
}
